import React from 'react';
import IndividualTileBadge from '../Search/IndividualTileBadge';
import {ViewListIcon} from "../vectors/ViewListIcon";

const FirmIndividualTilesServices = ({services, profileLink}) => {
    const renderService = label => {
        return (
            <p
                className='text-sm leading-[1.43] m-0 test-service-name text-primary-blue '
                key={label}
            >
                {label}
            </p>
        );
    }

    const renderServices = () => {
        if (services.length === 0) return null;

        return services.map((service, i) =>
            i < 4 ? renderService(service.label) : ''
        );
    }

    return (
        <div>
            <IndividualTileBadge
                label="Services offered:"
                icon={<ViewListIcon />}
            />
            <div className='pl-8'>
                <>
                    {renderServices()}
                    {
                        services.length > 4 ?
                                <a href={profileLink} className= 'text-sm no-underline text-bright-blue test-more-services '>{('+ ' + (services.length - 4) + ' more')}</a>
                            : null
                    }
                </>
            </div>
        </div>
    );
};

export default FirmIndividualTilesServices;
